import React from 'react';
import GongqiFormItemControl from './GongqiFormItemControl';
import FormItemDesign from '../FormItemDesign';
import FormItemConst from '../FormItemConst';

export default class FormItemDesignControl extends GongqiFormItemControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemDesignControl";
	}

	getProperty_AllowEdit_GOTFinal()
	{
		if(this.finalAllowEditGOT)
			return this.finalAllowEditGOT;
		
		var result = this.getProperty_AllowEdit_GOT();
		if(!result)
			return false;
		return result;
	}

	getProperty_AllowEdit_UserSetFinal()
	{
		var result = this.getProperty_AllowEdit_UserSet();
		if(!result)
		{
			return false;
		}
		
		return result;
	}

	getProperty_Visible_Final()
	{
		return true;
	}
	
	getProperty_Visible_GOT()
	{
		return true;
	}
	
	getProperty_Visible_GOTFinal()
	{
		return true;
	}
	
	getProperty_Visible_Loop()
	{
		return true;
	}
	
	getProperty_Visible_UserSetFinal()
	{
		return true;
	}
	
	getProperty_Visible_UserSet()
	{
		return true;
	}
	
	getProperty_Visible_UserSetLoop()
	{
		return true;
	}

	getProperty_Layout()
	{
		return this.xml.Properties.Layout.Value;
	}

	getIsWorkFlow()
	{
		if(this.parentXML.Properties.hasOwnProperty("Workflow"))
			return this.parentXML.Properties.Workflow.Value;
		if(!this.parentXML.Properties.hasOwnProperty("FormType"))
			return false;
		let formType = this.parentXML.Properties.FormType.Value;
		return formType == FormItemConst.PROPERTY_FORMTYPE_WORKFLOW;
	}

	getStyle(isPop)
	{
		let layout = this.xml.Properties.Layout.Value;
		
		let flexDirection = (layout=="horizontal"?"row":"column");
		let style = {
	      //flex-direction:flexDirection,
	      //align-items:"flex-start",
		  display:"flex"
		  //paddingTop:'2px'
		};
		let isWorkFlow = this.getIsWorkFlow();
		if(isWorkFlow)
		{
			style.flexGrow = 1;
		}
		else
		{
			style.width = "100%";style.height = "100%";
			if(window.isPopUp || isPop)
				style.height = "";
		}
	    style["flexDirection"] = flexDirection;
		style["alignItems"] = "flex-start";
		
		let propertyWidth = this.getProperty_Width();
		if(propertyWidth)
		{
			style["width"] = propertyWidth+"px";
		}
	    //if(window.isPopUp)style["justifyContent"] = "center";
	    //TODO最开始的时候为了解决滚动条问题加的-1
	    //style["margin"] = "-1px";
	    //style["overflow"] = 'auto';
	    /*if(this.props.isLookup)
	    {
	    	style["position"] = 'absolute';style["top"] = "34px";style["left"] = "200px";
	    }*/
		return style;
	}

	getComponentInstance(parent,forLookup,formLabel,formName,isPop,stringEditorEntityId,stringEditorInnerId)
	{
		//alert("FormDesign111");		
		return	<FormItemDesign xml={this.xml} formName={formName} parentItem={parent} formLabel={formLabel?formLabel:""} 
		 						forLookup={forLookup} customStyle={this.getStyle(isPop)} isPop={isPop} control={this}
		 						formId={this.formId} menuItemId={this.menuItemId} stringEditorEntityId={stringEditorEntityId}
		 						contextMenuData={this.contextMenuData} stringEditorInnerId={stringEditorInnerId}/>;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemDesignControl.js